import { useEffect, useRef, useContext } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { productShape } from "app/utils/propTypes";
import LookAlikeProduct from "app/pages/.shared/LookAlikeProduct/LookAlikeProduct";
import "./LookAlikeProducts.scss";
import useOnScreen from "app/pages/.shared/useOnScreen";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import AppGlobalsContext from "app/AppGlobalsContext";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { generateDestinationTitle, generateHotelName } from "app/utils/productUtils";
import { containsTrainTransportationTypes } from "app/utils/utils";
import { OFFER_CONTRACT_TYPES } from "app/constants";

const LookAlikeProducts = ({ products = [] }) => {
	const { track } = useAnalytics();
	const ref = useRef();
	const { shop } = useContext(AppGlobalsContext);

	const isElementOnScreen = useOnScreen({ ref, triggerOnce: true });

	useEffect(() => {
		if (isElementOnScreen && products.length > 0) {
			track("lookalike_Product_view", {
				products,
			});
		}
	}, [isElementOnScreen, products]);

	if (products.length === 0) {
		return false;
	}

	return (
		<div className="lookalike-products" ref={ref}>
			<Typography
				variant={TYPOGRAPHY_VARIANTS.XL}
				variantMD={TYPOGRAPHY_VARIANTS.XL3}
				isBold
				className="lookalike-products__title"
				component="h2"
			>
				<FormattedMessage id="lookalike.products.title" />
			</Typography>

			<div className="lookalike-products__list">
				{products.map((product, index) => (
					<LookAlikeProduct
						key={product.id}
						isRental={product?.contractType === OFFER_CONTRACT_TYPES.RENTAL}
						onClick={() =>
							track("lookalike_Product_click", {
								productUri: product.uri,
								position: `${index + 1}`,
							})
						}
						uri={product.uri}
						image={{
							src: product?.photos?.[0]?.url,
							thumbnail: product?.photos?.[0]?.thumbnail,
						}}
						title={generateDestinationTitle(shop, product)}
						subtitle={generateHotelName(product?.name, product?.category)}
						tripAdvisor={{
							id: product?.tripadvisor?.id,
							rating: product?.tripadvisor?.rating,
							reviewsCount: product?.tripadvisor?.reviewsCount,
						}}
						startingPrice={Number(product?.fromPriceType?.value) || 0}
						price={Number(product?.fromPriceType?.publicPrice) || 0}
						offerPriceType={product?.fromPriceType?.type}
						nbOfNights={product?.fromPriceType?.numberOfNights}
						includeFlightOption={product?.includeOfferWithFlight}
						includeTrainOption={containsTrainTransportationTypes(
							product?.transportationTypes
						)}
					/>
				))}
			</div>
		</div>
	);
};

LookAlikeProducts.propTypes = {
	products: PropTypes.arrayOf(productShape),
};

export default LookAlikeProducts;
